import { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { LessonEditor } from 'src/containers/academy/admin/creation/LessonEditor';
import academyService from 'src/services/api/academyService';
import { Message } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';
import { StudentProvider } from 'src/containers/academy/context/StudentContext';

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 1rem;

  @media (max-width: ${screenSizes.tablet}) {
    padding: 0.5rem;
  }
`;

const LessonEditorPage = () => {
  const { courseId, lessonId } = useParams();
  const history = useHistory();
  const [course, setCourse] = useState(null);
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch course data
        const courseResponse = await academyService.getAcademyCourses();
        const foundCourse = courseResponse.data?.AcademyCourses?.find(
          (c) => c.id === Number(courseId)
        );

        if (!foundCourse) {
          setError('Curso no encontrado');
          return;
        }

        setCourse(foundCourse);

        // If editing an existing lesson, fetch lesson data
        if (lessonId && lessonId !== 'new') {
          const lessonResponse = await academyService.getAcademyLessons();
          const foundLesson = lessonResponse.data?.AcademyLessons?.find(
            (l) => l.id === Number(lessonId)
          );

          if (foundLesson) {
            setLesson(foundLesson);
          }
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Error al cargar los datos');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [courseId, lessonId]);

  const handleSave = async (lessonData) => {
    try {
      if (lessonId && lessonId !== 'new') {
        // Update existing lesson
        await academyService.updateAcademyLesson(lessonId, lessonData);
      } else {
        // Create new lesson
        await academyService.createAcademyLesson(lessonData);
      }

      // Redirect back to admin dashboard
      history.push('/admin/academy');
    } catch (err) {
      console.error('Error saving lesson:', err);
      throw err;
    }
  };

  const handleCancel = () => {
    history.push('/admin/academy');
  };

  if (loading) {
    return (
      <PageContainer>
        <div style={{ textAlign: 'center', padding: '2rem' }}>Cargando...</div>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer>
        <Message negative>
          <Message.Header>Error</Message.Header>
          <p>{error}</p>
        </Message>
      </PageContainer>
    );
  }

  if (!course) {
    return (
      <PageContainer>
        <Message warning>
          <Message.Header>Curso no encontrado</Message.Header>
          <p>El curso especificado no existe.</p>
        </Message>
      </PageContainer>
    );
  }

  return (
    <StudentProvider>
      <PageContainer>
        <LessonEditor lesson={lesson} course={course} onSave={handleSave} onCancel={handleCancel} />
      </PageContainer>
    </StudentProvider>
  );
};

export default LessonEditorPage;
